var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:{
    'transform rotate-0': _vm.direction === 'down',
    'transform rotate-180': _vm.direction === 'up',
    'transform rotate-90': _vm.direction === 'right',
    'transform rotate-270': _vm.direction === 'left',
  },attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M13.3346 8.16658L12.3946 7.22658L8.66797 10.9466V2.83325H7.33464V10.9466L3.61464 7.21992L2.66797 8.16658L8.0013 13.4999L13.3346 8.16658Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }